import React, { createContext, useState, useContext } from 'react';

import { MenuContextData } from './interface';

const MenuContext = createContext<MenuContextData>({} as MenuContextData);

export const MenuProvider: React.FC = ({ children }) => {
  const [visible, setVisible] = useState<boolean>(() => {
    const data = localStorage.getItem('@commerceplus_dashboard:menu');
    const _visible = data === 'true' ? true : false;
    return _visible;
  });

  const toggleVisible = () => {
    const _visible = !visible;
    localStorage.setItem('@commerceplus_dashboard:menu', `${_visible}`);
    setVisible(_visible);
  };
  return (
    <MenuContext.Provider value={{ visible, toggleVisible }}>
      {children}
    </MenuContext.Provider>
  );
};

export function useMenu(): MenuContextData {
  const context = useContext(MenuContext);
  if (!context) {
    throw new Error('hook usado fora do contexto do menu!');
  }
  return context;
}
